function activeElements(customOptions) {
  var options = {
    selector: ".activeView",
    activeClass: "active",
    minWidth: 0,
    offset: 0,
  }
  for (var property in customOptions) {
    options[property] = customOptions[property]
  }

  var sections = document.querySelectorAll(options.selector)
  var screenWidth

  window.addEventListener("load", onLoadFunction)

  function onLoadFunction() {
    onResizeFunction()
    window.addEventListener("resize", onResizeFunction)
    window.addEventListener("scroll", startMain)
  }

  function onResizeFunction() {
    screenWidth = EMsize()
    startMain(screenWidth)
  }

  function isInViewport(e) {
    var offset = options.offset
    var rect = e.getBoundingClientRect()
    return (
      rect.bottom + offset > 0 &&
      rect.right > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.top - offset <
        (window.innerHeight || document.documentElement.clientHeight)
    )
  }

  function startMain() {
    var topDistance = this.pageYOffset
    var i, len

    for (i = 0, len = sections.length; i < len; i++) {
      var section = sections[i]
      var vis = isInViewport(section)

      if (vis != false && screenWidth) {
        section.classList.add(options.activeClass)
      } else {
        section.classList.remove(options.activeClass)
      }
    }
  } // end
} // end activeClasser
